<template>
  <div>
    <Toolbar>
      <template slot="left">
        <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50" >
          <h1><v-icon large>mdi-bug-check</v-icon>
            <span v-if="locale == 'fr' & item['qualityCheckTest'].namefr != ''">{{ item['qualityCheckTest'].namefr }}</span>
            <span v-else>{{ item['qualityCheckTest'].name }}</span>
          </h1>
        </v-toolbar-title>
      </template>
    </Toolbar>
    <br />

    <div v-if="item" class="table-qualitycheckvalue-show">
      <v-simple-table>
        <template slot="default">
          <thead>
            <tr>
              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>

              <th>{{ $t('global.field') }}</th>
              <th>{{ $t('global.value') }}</th>
            </tr>
          </thead>
          <tbody>
            <tr>

              <td><strong>{{ $t('qualitycheck.test.test') }} N°{{ $n(item['qualityCheckTest'].number) }}</strong></td>
              <td colspan=3>
                <v-simple-table>
                    <tbody>
                <tr>

                  <td><strong>{{ $t('qualitycheck.test.name') }}</strong></td>
                  <td>
                    <span v-if="locale == 'fr' & item['qualityCheckTest'].namefr != ''">{{ item['qualityCheckTest'].namefr }}</span>
                    <span v-else>{{ item['qualityCheckTest'].name }}</span>
                  </td>

                  <td><strong>{{ $t('qualitycheck.test.issue') }}</strong></td>
                  <td>
                    <span v-if="locale == 'fr' & item['qualityCheckTest'].issuefr != ''">{{ item['qualityCheckTest'].issuefr }}</span>
                    <span v-else>{{ item['qualityCheckTest'].issue }}</span>
                  </td>
                  <td><strong>{{ $t('qualitycheck.test.comment') }}</strong></td>
                  <td>
                    <span v-if="locale == 'fr' & item['qualityCheckTest'].commentfr != ''">{{ item['qualityCheckTest'].commentfr }}</span>
                  <span v-else>{{ item['qualityCheckTest'].comment }}</span>
                  </td>
                </tr>
              </tbody>
              </v-simple-table>
              </td>

            </tr>
            <tr>

              <td><strong>{{ $t('qualitycheck.qualitycheck.qualitycheckvalue') }}</strong></td>
              <td>
                  <span v-if="item['value'].name == 'Passed'"  ><v-icon color="green">mdi-check-circle</v-icon> {{ item['value'].name }}</span>
                  <span v-else><v-icon color="red">mdi-close-circle</v-icon>{{ item['value'].name }}</span>
              </td>
              <td><strong>{{ $t('global.date') }}</strong></td>
              <td>
                {{ formatDate(item['updated'], 'long') }}
              </td>
            </tr>
            <tr>
              <td><strong>{{ $t('qualitycheck.qualitycheck.comment') }}</strong></td>
              <td colspan=3>
                  {{ item['comment'] }}
              </td>
            </tr>

          </tbody>
        </template>
      </v-simple-table>
    </div>

    <Loading :visible="isLoading" />
  </div>
</template>

<script>
import i18n from '../../i18n.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import Loading from '../../components/Loading';
import ShowMixin from '../../mixins/ShowMixin';
import AccessMixin from '../../mixins/AccessMixin';
import Toolbar from '../../components/Toolbar';

const servicePrefix = 'QualityCheckValue';

export default {
  name: 'QualityCheckValueShow',
  servicePrefix,
  components: {
      Loading,
      Toolbar
  },
  mixins: [ShowMixin,AccessMixin],
  computed: {
    ...mapFields('qualitycheckvalue', {
      isLoading: 'isLoading'
    }),
    ...mapGetters('qualitycheckvalue', ['find'])
    ,
    locale() {
      return i18n.locale;
    },
  },
  methods: {
    ...mapActions('qualitycheckvalue', {
      deleteItem: 'del',
      reset: 'reset',
      retrieve: 'load'
    })
  }
};
</script>
